
import * as Yup from 'yup';
import { reverseShape } from '../helpers/reverse-shape';

import {
    addressLine,
    city,
    country,
    fullName,
    identificationNumber,
    passportIssueDate,
    passportExpiryDate,
    identificationType,
    passportPlaceOfIssue,
    gender,
    email,
    fullContact,
    phoneType,
    addressType,
    postcode,
    dialCode,
    phoneNumber,
    title,
    state,
    date
} from '../helpers/validations';

export const UpdateAddressFormSchema = Yup.object().shape(
    reverseShape({
        type: addressType.required(),
        addressLine1: Yup.string().required().matches(/^[ A-Za-z0-9_@.,/#&\/+-]*$/).min(3).max(100),
        addressLine2: Yup.string().optional().matches(/^[ A-Za-z0-9_@.,/#&\/+-]*$/).min(0).max(100),
        city: city.required(),
        state: state.required(),
        postcode: postcode.required(),
        country: country.optional(),
    })
)